angular.module('v3sWbtPlayerApp').factory('v3sScormDataLms2004AdapterService', ["v3sLog", function (v3sLog) {

    // SCORM Constants
    var VARS = {
        SCORM_TRUE: { value: 'true' },
        SCORM_FALSE: { value: 'false' },

        STATUS_COMPLETED: { value: 'cmi.completion_status' },
        STATUS_PASSED: { value: 'cmi.success_status' },

        SCORE_RAW: { value: 'cmi.score.raw' },
        SCORE_MIN: { value: 'cmi.score.min' },
        SCORE_MAX: { value: 'cmi.score.max' },
        SCORE_SCALED: { value: 'cmi.score.scaled' },

        PROGRESS: { value: 'cmi.progress_measure' },

        EXIT: { value: 'cmi.exit' },

        SUSPEND_DATA: { value: 'cmi.suspend_data' },
        GLOBAL_SUSPEND_DATA: { value: 'cmi.viwis.global.suspend_data' },

        ADL_DATA_COUNT: { value: 'adl.data._count' },
        ADL_DATA_ID: { value: 'adl.data.[PARAM].id' },
        ADL_DATA_STORE: { value: 'adl.data.[PARAM].store' },

        SESSION_TIME: { value: 'cmi.session_time' },

        STUDENT_ID: { value: 'cmi.learner_id' },
        STUDENT_NAME: { value: 'cmi.learner_name' },

        VALID_REQUEST_CONTINUE: { value: 'adl.nav.request_valid.continue' },
        VALID_REQUEST_PREVIOUS: { value: 'adl.nav.request_valid.previous' },
        VALID_REQUEST_CHOICE: { value: 'adl.nav.request_valid.jump.{target=[PARAM]}' },

        NAV_REQUEST: { value: 'adl.nav.request' },
        NAV_REQUEST_CONTINUE: { value: 'continue' },
        NAV_REQUEST_PREVIOUS: { value: 'previous' },
        NAV_REQUEST_CHOICE: { value: '{target=[PARAM]}jump' },

        LOCATION: { value: 'cmi.location' }
    };

    //SCORM API
    var API = null;
    var initialized = false;

    function isError(number) {
        return number !== "0" && number !== 0;
    }

    function findAPI(win) {
        var findAPITries = 0;
        var findAPITriesMax = 5;
        while (!win.API_1484_11 && !!win.parent && win.parent !== win) {
            findAPITries++;

            if (findAPITries > findAPITriesMax) {
                break;
            } else {
                win = win.parent;
            }
        }

        var result = { adapter: null, findAPITries: findAPITries };
        if (!!win.API_1484_11) {
            result.adapter = {
                type: typeof win.API_1484_11,
                Initialize: typeof win.API_1484_11.Initialize,
                Terminate: typeof win.API_1484_11.Terminate,
                GetValue: typeof win.API_1484_11.GetValue,
                SetValue: typeof win.API_1484_11.SetValue,
                Commit: typeof win.API_1484_11.Commit,
                GetLastError: typeof win.API_1484_11.GetLastError,
                GetErrorString: typeof win.API_1484_11.GetErrorString,
                GetDiagnostic: typeof win.API_1484_11.GetDiagnostic
            };
        }
        v3sLog.debug("FindAPI", result);

        if (!!win.API_1484_11) {
            return win.API_1484_11;
        } else {
            return null;
        }
    }

    function getAPI() {
        var theAPI = null;

        v3sLog.debug("Search for Adapter in this window...");
        theAPI = findAPI(window);


        if (!theAPI && !!window.opener) {
            v3sLog.debug("Search for Adapter in opener...");
            theAPI = findAPI(window.opener);
        }

        if (!theAPI && !!window.top && !!window.top.opener) {
            v3sLog.debug("Search for Adapter in opener...");
            theAPI = findAPI(window.top.opener);
        }

        return theAPI;
    }

    /*
     * Init connection with LMS
     */
    function initialize() {
        API = getAPI();
        if (!API) {
            throw "No LMS adapter found.";
        }

        v3sLog.debug("Initialize");
        var result = API.Initialize("");
        v3sLog.debug("Initialize Result", result);

        if (result === VARS.SCORM_FALSE.value) {
            var errorNumber = API.GetLastError();
            var errorDescription = "Error: " + API.GetLastError() +
                " Description: " + API.GetErrorString(errorNumber) +
                " Diagnostic: " + API.GetDiagnostic(errorNumber);
            v3sLog.debug("LMS Error", errorDescription);
            throw errorDescription;
        } else {
            initialized = true;
        }
    }

    function finish(forced) {
        setValue(VARS.EXIT, "suspend");

        v3sLog.debug("Terminate");
        var result = API.Terminate("");
        v3sLog.debug("Terminate Result", result);

        if (result === VARS.SCORM_FALSE.value) {
            var errorNumber = API.GetLastError();
            var errorDescription = "Error: " + API.GetLastError() +
                    " Description: " + API.GetErrorString(errorNumber) +
                    " Diagnostic: " + API.GetDiagnostic(errorNumber);
            v3sLog.debug("LMS Error", errorDescription);
            throw errorDescription;
        }

        API = null;
        initialized = false;
    }

    function getValue(scormKey, param) {
        var result = "";

        if (!!scormKey && !!scormKey.value) {

            var key = scormKey.value;
            if (typeof param !== 'undefined') {
                key = key.replace("[PARAM]", param);
            }

            v3sLog.debug("GetValue", key);
            result = API.GetValue(key);
            v3sLog.debug("GetValue Result", result);

            if (result === "") {
                var errorNumber = API.GetLastError();
                if (isError(errorNumber)) {
                    var errorDescription = "Error: " + errorNumber +
                        " Description: " + API.GetErrorString(errorNumber) +
                        " Diagnostic: " + API.GetDiagnostic(errorNumber);
                    v3sLog.debug("LMS Error", errorDescription);
                    if (errorNumber != 403) { // 403 => Variable nicht gesetzt
                        throw errorDescription;
                    }
                }
            }

            if (scormKey == VARS.VALID_REQUEST_CHOICE) { //Bug in ILIAS LMS
                result = VARS.SCORM_TRUE.value;
            }
        }

        return result;
    }

    function setValue(scormKey, scormValue, param) {
        if (!!scormKey && !!scormKey.value) {
            var key = scormKey.value;
            var value = scormValue;

            if (!!scormValue && !!scormValue.value) {
                value = scormValue.value;
            }
            if (typeof param !== 'undefined') {
                value = value.replace("[PARAM]", param);
                key = key.replace("[PARAM]", param);
            }

            v3sLog.debug("SetValue", { key: key, value: value });
            var result = API.SetValue(key, value);
            v3sLog.debug("SetValue Result", result);

            if (result == VARS.SCORM_FALSE.value) {
                var errorNumber = API.GetLastError();
                var errorDescription = "Error: " + API.GetLastError() +
                        " Description: " + API.GetErrorString(errorNumber) +
                        " Diagnostic: " + API.GetDiagnostic(errorNumber);
                v3sLog.debug("LMS Error", errorDescription);
                throw errorDescription;
            }
        }
    }

    function commit() {
        v3sLog.debug("Commit");
        var result = API.Commit("");
        v3sLog.debug("Commit Result", result);

        if (result === VARS.SCORM_FALSE.value) {
            var errorNumber = API.GetLastError();
            var errorDescription = "Error: " + API.GetLastError() +
                    " Description: " + API.GetErrorString(errorNumber) +
                    " Diagnostic: " + API.GetDiagnostic(errorNumber);
            v3sLog.debug("LMS Error", errorDescription);
            throw errorDescription;
        }
    }

    function isInitialized() {
        return !!API && initialized;
    }

    function getGlobalData() {
        var data = "";
        var bucketsCount = parseInt(getValue(VARS.ADL_DATA_COUNT));

        for (var i = 0; i < bucketsCount; i++) {
            if (getValue(VARS.ADL_DATA_ID, i) == VARS.GLOBAL_SUSPEND_DATA.value) {
                data = getValue(VARS.ADL_DATA_STORE, i);
                break;
            }
        }

        return data;
    }

    function setGlobalData(data) {
        var bucketsCount = parseInt(getValue(VARS.ADL_DATA_COUNT));

        for (var i = 0; i < bucketsCount; i++) {
            if (getValue(VARS.ADL_DATA_ID, i) == VARS.GLOBAL_SUSPEND_DATA.value) {
                setValue(VARS.ADL_DATA_STORE, data, i);
                break;
            }
        }
    }

    return {
        initialize: initialize,
        isInitialized: isInitialized,
        finish: finish,
        getValue: getValue,
        setValue: setValue,
        commit: commit,
        getGlobalData: getGlobalData,
        setGlobalData: setGlobalData,
        getAPI: getAPI,
        VARS: VARS
    };
}]);